import { type FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { broadcast_logout, type LogoutMessage } from "@/modules/app/messaging/broadcast.ts";
import { logout } from "@/redux/modules/auth.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";

export const LogoutPage: FC = () => {
  const dispatch = useDispatch<ReduxDispatch>();
  // const navigate = useNavigate();

  useEffect(() => {
    broadcast_logout?.postMessage({ logout: true } satisfies LogoutMessage);
    void dispatch(logout());
  }, [dispatch]);

  return null;
};
